<template>
  <!-- 对话框 -->
  <el-drawer title="添加用户信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">

    <!-- 基本信息表单 -->
    <div class="form-box">

      <el-form ref="form" :model="submit_data" label-width="80px" style="overflow-y: auto; height: 85vh;">

        <el-form-item label="客户名称:" label-width='120px'>
          <el-input v-model="submit_data.name" :placeholder="submit_rules.name.placeholder" style="width: 80%;">
          </el-input>
        </el-form-item>

        <el-form-item label="手机号码:" label-width='120px'>
          <el-input v-model="submit_data.phone" :placeholder="submit_rules.phone.placeholder" style="width: 80%;" maxlength=11>
          </el-input>
        </el-form-item>

        <el-form-item label="备注:" label-width='120px'>
          <el-input v-model="submit_data.remarks" :placeholder="submit_rules.remarks.placeholder" style="width: 80%;">
          </el-input>
        </el-form-item>



      </el-form>

      <!-- 对话框底部按钮 -->
      <div style="display: flex;justify-content: center">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="closeDialog">关闭</el-button>
      </div>

    </div>

  </el-drawer>
</template>

<script>
  var _this;

  import bus from '../../common/bus.js';
  export default {
    props: {
      'isShow': Boolean,
    },
    components: {

    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

      },

    },
    data() {
      return {
        show: false,


        // 表单数据
        submit_data: {
          name: '',
          phone: '',
          remarks: '',
        },

        submit_rules: {
          name: {
            placeholder: '客户名称',
            rules: {
              required: false,
              message: '客户名称',
              regulation: 'elt_str',
              rulesData: 20
            }
          },
          phone: {
            placeholder: '手机号码必须为11位',
            rules: {
              required: true,
              message: '手机号码必须为11位',
              regulation: 'eq_str',
              rulesData: 11
            }
          },
          remarks: {
            placeholder: '备注，200字节之内',
            rules: {
              required: false,
              message: '备注，200字节之内',
              regulation: 'elt_str',
              rulesData: 200
            }
          }
        },

      };
    },
    created() {
      _this = this;

    },
    methods: {




      // 关闭方法
      closeDialog() {
        _this.submit_data = {
          name: '',
          phone: '',
          remarks: '',
        }
        _this.show = false;
      },

       // 提交
       onSubmit() {
        _this.$post(
            "/consumer/addConsumerSubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
            this.$message.success(res.msg);
          }).catch(res => {

          })
      },

    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>